var TIMER_SELECTOR = '.js-timer';
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Timer(el) {
	var $el = $(el);
	var $timer = $el.find(TIMER_SELECTOR);
	var expire = $el.data('timer');
	var interval = null

	if (expire) {
		interval = setInterval(function() {
			var now = Math.ceil(Date.now() / 1000);
			var remaining = expire - now;
			var seconds = remaining % 60;
			var minutes = Math.floor(remaining / 60);

			if (seconds < 10) {
				seconds = '0' + seconds;
			}

			if ( minutes < 10) {
				minutes = '0' + minutes;
			}

			$timer.text(minutes + ':' + seconds);

			if (remaining <= 0) {
				clearInterval(interval);
				interval = null;
				window.location = window.location.href;
			}
		}, 1000);
	}
}

module.exports = Timer;
